import React, { useEffect, useState } from "react";
import CustomPagination from "../components/Shared/CustomPagination";
import { FaEye, FaPrint } from "react-icons/fa";
import { IoIosSend } from "react-icons/io";
import CustomTable from "../components/Shared/CustomTable";
import Filters from "./Filters";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import supergitHIS from "../api/supergitHIS";
import validSupergitHIS from "../api/validSupergitHIS";
import toast from "react-hot-toast";
import TableLoading from "../components/Shared/TableLoading";
import SharedButton from "../components/Shared/SharedButton";
import { getDateRange } from "./ThirdParty";
import moment from "moment";
import { TfiStatsUp } from "react-icons/tfi";
import { ProgressSpinner } from "primereact/progressspinner";
import { FaFileInvoice, FaPencil } from "react-icons/fa6";
import { MdCancel } from "react-icons/md";
import InvoiceDetails from "./InvoiceDetails";
import { useSelector } from "react-redux";
import GalleryUpdate from "./GalleryUpdate";
import { getGalleryInvoiceHTML, PRINTINVOICES } from "./GalleryInvoicePrint";

const GalleryInvoicesMain = ({ activeTab }) => {
  const key = "galley-main-filters";
  const { user } = useSelector((state) => state?.auth);
  const [openFilter, setOPenFilters] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [zatcaIndex, setZatcaIndex] = useState(-1);
  const [zatcaLoading, setZatcaLoading] = useState(false);
  const [logLoading, setLogLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [editVisible, setEditVisible] = useState(false);
  const [creditNote, setCreditNote] = useState(false);
  const [vsData, setVsData] = useState(null);
  const [isPollLoading, setIsPollLoading] = useState(false);
  const [date, setDate] = useState({
    from: getDateRange("lastDay").from,
    to: getDateRange("lastDay").to,
  });
  const [payload, setPayload] = useState(
    localStorage.getItem(key)
      ? JSON.parse(localStorage.getItem(key))
      : {
        orderDateFrom: null,
        orderDateTo: null,
        CustomerOrderID: null,
        zatcaStatus: null,
        galleryId: user?.thirdparty_branch_id,
        page: 1,
        pageSize: 10,
      },
  );
  const [data, setData] = useState([]);
  const [isListLoading, setIsListLoading] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const templateBody = (rowData, col) => (
    <div className="flex gap-3 items-center justify-center">
      <FaFileInvoice
        className=" cursor-pointer"
        size={16}
        title="Invoice Details"
        onClick={() => {
          getInvoiceDetails(rowData?.CustomerOrderID).then(() => {
            setVisible(true);
          });
        }}
      />

      <FaPencil
        className=" cursor-pointer"
        size={16}
        title="Invoice Details"
        onClick={() => {
          setCreditNote(false);
          getInvoiceDetails(rowData?.CustomerOrderID).then(() => {
            setEditVisible(true);
          });
        }}
      />

      {rowData?.ZatcaStatus || rowData?.zatcaStatus == "REPORTED" && (
        <FaPrint
          className=" cursor-pointer"
          size={16}
          title={t("Details")}
          onClick={() => {
            navigate(`/zatca/thirdparty/invoice-details/${rowData.InvoiceId}`, {
              state: {
                status: rowData?.ZatcaStatus || rowData?.zatcaStatus,
                module: activeTab,
                url: "invoices/zatca",
                invoiceData: rowData,
              },
            });
          }}
        />
      )}

      {logLoading && col?.rowIndex == zatcaIndex ? (
        <div className="w-4 h-4 border-2 border-black border-t-transparent rounded-full animate-spin" />
      ) : (
        <TfiStatsUp
          className=" cursor-pointer"
          size={16}
          title="View Logs"
          onClick={() => handleViewLogs(rowData.CustomerOrderID)}
        />
      )}

      {rowData?.ZatcaStatus || rowData?.zatcaStatus === "REPORTED" ? null : zatcaLoading &&
        col?.rowIndex == zatcaIndex ? (
        <div className="w-4 h-4 border-2 border-black border-t-transparent rounded-full animate-spin" />
      ) : (
        <IoIosSend
          disabled={zatcaLoading}
          className=" cursor-pointer"
          size={16}
          title={t("Send To Zatca")}
          onClick={() => {
            SendToZatca(rowData.CustomerOrderID);
          }}
        />
      )}

      <MdCancel
        size={28}
        className="!p-1 !text-red-500 cursor-pointer"
        title={t("Cancel")}
        onClick={() => {
          setCreditNote(true);
          getInvoiceDetails(rowData?.CustomerOrderID).then(() => {
            setEditVisible(true);
          });
        }}
      />
    </div>
  );

  const statusTemplate = (rowData) => {
    return (
      <div>
        {rowData?.ZatcaStatus || rowData?.zatcaStatus === "REPORTED" ? (
          <div className="bg-green-500 !w-[100px] p-1 text-center text-white rounded-md">
            {rowData?.ZatcaStatus || rowData?.zatcaStatus}
          </div>
        ) : (
          <div className="bg-red-500 p-1 !w-[100px] text-center text-white rounded-md">
            UNREPORTED
          </div>
        )}
      </div>
    );
  };

  const columnsData = [
    { body: templateBody, header: t("Actions") },
    { body: statusTemplate, header: t("Zatca Status") },
    {
      field: "CustomerOrderID",
      header: t("Order Id"),
      style: { width: "8rem" },
    },
    { body: (rowData) => rowData?.InvoiceId, header: t("invoiceNumber") },
    { field: "CustomerName", header: t("Customer Name") },
    {
      field: "OrderDate",
      header: t("Order Date"),
      body: (rowData) =>
        moment(rowData?.orderDate || rowData?.OrderDate).format(
          "DD-MM-YYYY HH:mm a",
        ),
    },
    { field: "GalleryName", header: t("Store Name") },
    { field: "LocalSerial", header: t("Local Serial") },
    { field: "SalesPerson", header: t("Sales Person Name") },

    {
      field: "TotalPrice",
      header: t("Total Price"),
      body: (rowData) => `${rowData.TotalPrice} SAR`,
    },
    { field: "GalleryAddress", header: t("Address") },
    {
      body: (data) => (
        <>
          {data?.InsuranceCompanyName != "" || null
            ? data?.InsuranceCompanyName
            : "Cash"}
        </>
      ),
      header: t("Insurance"),
    },
    { body: () => <div>B2C</div>, header: t("Type") },
  ];

  const onPageChange = (page, rowsPerPage) => {
    setPayload({ ...payload, page, pageSize: rowsPerPage });
  };

  const SendToZatca = async (id) => {
    try {
      setZatcaLoading(true);
      const res = await validSupergitHIS.post(
        `zatca2/sendInvoiceToZatcaCustomer/${id}/8ab7f7d1-8fa2-47a8-966d-97fbec298e31`,
      );
      toast.success(res.data?.message);
      await fetchListData(payload);
      setZatcaLoading(false);
    } catch (err) {
      setZatcaLoading(false);
      console.error(err);
    }
  };

  const handleViewLogs = async (id) => {
    try {
      setLogLoading(true);
      const res = await validSupergitHIS.get(`invoices/zatca/logs/${id}`);
      console.log(res);
      setLogLoading(false);
    } catch (err) {
      setLogLoading(false);
      console.error(err);
    }
  };

  const fetchPollData = async () => {
    setIsPollLoading(true);
    try {
      const response = await validSupergitHIS.post(
        `hussam/transfer/customer-orders/sync?from_date=${date.to}`,
      );
      toast.success(response?.data?.message);
      fetchListData(payload);
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setIsPollLoading(false);
    }
  };

  const fetchListData = async (filters = payload) => {
    setIsListLoading(true);
    try {
      const response = await validSupergitHIS.post(
        "invoices/customerInvoices/filter",
        filters,
      );
      setData(response.data || []);
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setIsListLoading(false);
    }
  };

  const getInvoiceDetails = async (payload) => {
    setIsListLoading(true);
    try {
      const response = await validSupergitHIS.get(
        `invoices/customerInvoices/details/${payload}`,
      );
      const data = response.data;
      setVsData(data);
      return data;
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setIsListLoading(false);
    }
  };

  useEffect(() => {
    fetchListData(payload);
  }, [payload.page, payload?.pageSize]);

  return (
    <div>
      <div className="flex items-center justify-end mb-2 gap-2">
        <SharedButton
          icon="pi pi-credit-card"
          label={
            <div className="flex items-center gap-2">{t("Credit Note")} </div>
          }
          className="bg-primary primary-btn"
          onClick={() => {
            setCreditNote((prevState) => true);
            setEditVisible(true);
          }}
        />
        <SharedButton
          icon="pi pi-sync"
          label={
            <div className="flex items-center gap-2">
              {t("Polling")}{" "}
              {isPollLoading && (
                <ProgressSpinner
                  className="w-5 h-5 spinner-white"
                  style={{ stroke: "white" }}
                />
              )}
            </div>
          }
          disabled={isPollLoading}
          className="bg-primary primary-btn"
          onClick={fetchPollData}
        />
        {/* <SharedButton
          icon="pi pi-filter"
          label={t("apply_filters")}
          severity="warning"
          outlined
          className="!p-1.5 font-extralight !border-primary !text-primary"
          onClick={() => setOPenFilters(true)}
        /> */}
      </div>
      <Filters
        storageKey={key}
        visible={openFilter}
        setVisible={() => setOPenFilters(false)}
        filters={payload}
        setFilters={setPayload}
        fetchData={fetchListData}
        loading={isLoading}
        type="gallery"
      />
      <CustomTable
        setZatcaIndex={setZatcaIndex}
        data={data?.data}
        isLoading={isListLoading || zatcaLoading || logLoading || isPollLoading}
        loadingIcon={<TableLoading />}
        columns={columnsData}
        rows={data.total}
      />

      <CustomPagination
        currentPage={data?.page || payload?.page}
        rowsPerPage={data?.page_size || data?.pageSize || payload?.pageSize || 10}
        totalRecords={
          data?.total_pages ||
          data?.totalPages ||
          Math.ceil(
            (data?.total_records ||
              data?.totalRecords ||
              data?.summary?.totalRecords ||
              data?.total_record ||
              0) / (data?.page_size || data?.pageSize || payload?.pageSize || 10),
          )
        }
        totalRecord={
          data?.total_records ||
          data?.totalRecords ||
          data?.summary?.totalRecords ||
          data?.total_record ||
          0
        }
        onPageChange={onPageChange}
      />

      <InvoiceDetails
        visible={visible}
        onHide={() => {
          setVisible(false);
          setVsData(null);
        }}
        data={vsData}
        type="gallery"
      />
      <GalleryUpdate
        fetchAgain={fetchListData}
        setVisible={setEditVisible}
        invoiceData={vsData}
        setInvoiceData={setVsData}
        visible={editVisible}
        creditNote={creditNote}
      />
    </div>
  );
};

export default GalleryInvoicesMain;
